export const alpha3ToAlpha2 = {
  ABW: "aw",
  AFG: "af",
  AGO: "ao",
  AIA: "ai",
  ALA: "ax",
  ALB: "al",
  AND: "ad",
  ARE: "ae",
  ARG: "ar",
  ARM: "am",
  ASM: "as",
  ATA: "aq",
  ATF: "tf",
  ATG: "ag",
  ATC: "au",
  AUS: "au",
  AUT: "at",
  AZE: "az",
  BDI: "bi",
  BEL: "be",
  BEN: "bj",
  BES: "bq",
  BFA: "bf",
  BGD: "bd",
  BGR: "bg",
  BHR: "bh",
  BHS: "bs",
  BIH: "ba",
  BJN: "co",
  BLM: "bl",
  BLR: "by",
  BLZ: "bz",
  BMU: "bm",
  BOL: "bo",
  BRA: "br",
  BRI: "br",
  BRB: "bb",
  BRN: "bn",
  BRT: "eg",
  BTN: "bt",
  BVT: "bv",
  BWA: "bw",
  CAF: "cf",
  CAN: "ca",
  CCK: "cc",
  CHE: "ch",
  CHL: "cl",
  CHN: "cn",
  CIV: "ci",
  CLP: "fr",
  CMR: "cm",
  CNM: "cy",
  COD: "cd",
  COG: "cg",
  COK: "ck",
  COL: "co",
  COM: "km",
  CPV: "cv",
  CRI: "cr",
  CSI: "au",
  CUB: "cu",
  CUW: "cw",
  CXR: "cx",
  CYM: "ky",
  CYN: "cy",
  CYP: "cy",
  CZE: "cz",
  DEU: "de",
  DJI: "dj",
  DMA: "dm",
  DNK: "dk",
  DOM: "do",
  DZA: "dz",
  ECU: "ec",
  EGY: "eg",
  ERI: "er",
  ESB: "cy",
  ESH: "eh",
  ESP: "es",
  EST: "ee",
  ETH: "et",
  EUR: "eu",
  FIN: "fi",
  FJI: "fj",
  FLK: "fk",
  FRA: "fr",
  FRO: "fo",
  FSM: "fm",
  GAB: "ga",
  GBR: "gb",
  GEO: "ge",
  GGY: "gg",
  GHA: "gh",
  GIB: "gi",
  GIN: "gn",
  GLP: "gp",
  GMB: "gm",
  GNB: "gw",
  GNQ: "gq",
  GRC: "gr",
  GRD: "gd",
  GRL: "gl",
  GTM: "gt",
  GUF: "gf",
  GUM: "gu",
  GUY: "gy",
  HKG: "hk",
  HMD: "hm",
  HND: "hn",
  HRV: "hr",
  HTI: "ht",
  HUN: "hu",
  IDN: "id",
  IMN: "im",
  IND: "in",
  IOT: "io",
  IOA: "au",
  IRL: "ie",
  IRN: "ir",
  IRQ: "iq",
  ISL: "is",
  ISR: "il",
  ITA: "it",
  JAM: "jm",
  JEY: "je",
  JOR: "jo",
  JPN: "jp",
  KAB: "kz",
  KAS: "in",
  KAZ: "kz",
  KEN: "ke",
  KGZ: "kg",
  KHM: "kh",
  KIR: "ki",
  KNA: "kn",
  KOR: "kr",
  KWT: "kw",
  LAO: "la",
  LBN: "lb",
  LBR: "lr",
  LBY: "ly",
  LCA: "lc",
  LIE: "li",
  LKA: "lk",
  SLB: "sb",
  SLE: "sl",
  SLV: "sv",
  SMR: "sm",
  SOM: "so",
  SOL: "so",
  SPM: "pm",
  SRB: "rs",
  SSD: "ss",
  STP: "st",
  SUR: "sr",
  SVK: "sk",
  SVN: "si",
  SWE: "se",
  SWZ: "sz",
  SXM: "sx",
  SYC: "sc",
  SYR: "sy",
  TCA: "tc",
  TCD: "td",
  TGO: "tg",
  THA: "th",
  TJK: "tj",
  TKL: "tk",
  TKM: "tm",
  TLS: "tl",
  TON: "to",
  TTO: "tt",
  TUN: "tn",
  TUR: "tr",
  TUV: "tv",
  TWN: "tw",
  TZA: "tz",
  UGA: "ug",
  UKR: "ua",
  UMI: "um",
  UNK: "xk",
  URY: "uy",
  USA: "us",
  USG: "us",
  UZB: "uz",
  VAT: "va",
  VCT: "vc",
  VEN: "ve",
  VGB: "vg",
  VIR: "vi",
  VNM: "vn",
  VUT: "vu",
  WLF: "wf",
  WSB: "cy",
  WSM: "ws",
  YEM: "ye",
  ZAF: "za",
  ZMB: "zm",
  ZWE: "zw",
  LTU: "lt",
  LSO: "ls",
  LUX: "lu",
  LVA: "lv",
  MAC: "mo",
  MAF: "mf",
  MAR: "ma",
  MCO: "mc",
  MDA: "md",
  MDG: "mg",
  MDV: "mv",
  MEX: "mx",
  MHL: "mh",
  MKD: "mk",
  MLI: "ml",
  MLT: "mt",
  MMR: "mm",
  MNE: "me",
  MNG: "mn",
  MNP: "mp",
  MOZ: "mz",
  MRT: "mr",
  MSR: "ms",
  MTQ: "mq",
  MUS: "mu",
  MWI: "mw",
  MYS: "my",
  MYT: "yt",
  NAM: "na",
  NCL: "nc",
  NER: "ne",
  NFK: "nf",
  NGA: "ng",
  NIC: "ni",
  NIU: "nu",
  NLD: "nl",
  NOR: "no",
  NPL: "np",
  NRU: "nr",
  NZL: "nz",
  OMN: "om",
  PAK: "pk",
  PAN: "pa",
  PCN: "pn",
  PER: "pe",
  PGA: "ph",
  PHL: "ph",
  PLW: "pw",
  PNG: "pg",
  POL: "pl",
  PRI: "pr",
  PRK: "kp",
  PRT: "pt",
  PRY: "py",
  PSE: "ps",
  PYF: "pf",
  QAT: "qa",
  REU: "re",
  ROU: "ro",
  RUS: "ru",
  RWA: "rw",
  SAU: "sa",
  SCR: "ph",
  SDN: "sd",
  SEN: "sn",
  SER: "co",
  SGP: "sg",
  SGS: "gs",
  SHN: "sh",
  SJM: "sj",
  SPI: "ar",
};
